var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAi = function SvgAi(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    stroke: "currentColor",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    strokeMiterlimit: 5.25,
    d: "M15.5 6c-.633 3.042-1.057 3.721-3.97 4.5 2.913.779 3.337 1.458 3.97 4.5.61-2.933.931-3.687 3.97-4.5-2.912-.779-3.337-1.458-3.97-4.5Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    strokeMiterlimit: 10.471,
    d: "M7.97 16.5c-.14.676-.235.827-.882 1 .647.173.742.324.882 1 .136-.652.207-.82.883-1-.648-.173-.742-.324-.883-1ZM4.882 7c-.14.676-.235.827-.882 1 .647.173.742.324.882 1 .136-.652.207-.82.883-1-.648-.173-.742-.324-.883-1Z"
  })));
};
export default SvgAi;